import dayjs from 'dayjs'

/**
 * 시간표기형 공통포맷터
 * @params endDateTimeISO 종료시간까지 표기하는 경우
 * @params timeFormat 포맷 https://day.js.org/docs/en/display/format#list-of-all-available-formats
 */
export const formatDisplayVisitTime = ({
  dateTimeISO,
  endDateTimeISO,
  timeFormat = 'A h:mm',
}: {
  dateTimeISO?: string | null
  endDateTimeISO?: string | null
  timeFormat?: string
}): {
  displayTime: string
  altText: string
} => {
  const dateTimeDayjs = dayjs(dateTimeISO)

  if (!dateTimeISO || !dateTimeDayjs.isValid())
    return {
      displayTime: '',
      altText: '',
    }

  const displayTime = dateTimeDayjs.format(timeFormat)
  const altText = dateTimeDayjs.format('A h시 m분')

  const endDateTimeDayjs = dayjs(endDateTimeISO)

  if (!endDateTimeISO || !endDateTimeDayjs.isValid()) {
    return {
      displayTime,
      altText,
    }
  }

  const isSameAmPm = dateTimeDayjs.format('A') === endDateTimeDayjs.format('A')
  const timeOnlyFormat = timeFormat.replace(/[Aa]/g, '').trim() //오전 오후 제거

  const displayTimeRangeLabel = `${displayTime} - ${endDateTimeDayjs.format(isSameAmPm ? timeOnlyFormat : timeFormat)}`

  return {
    displayTime: displayTimeRangeLabel,
    altText: `${altText} - ${endDateTimeDayjs.format('A h시 m분')}`,
  }
}
